// Copyright (c) 2017 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import TranslatedInput from '../../translated-input';

class FacetFilter extends Component {

    state = {
        value: this.props.value
    };

    handleTranslatedInputChange = event => {

        const newValue = event.target.value;

        this.setState({
            value: newValue
        });

        this.props.onFilterChange(newValue);

    };

    render() {

        return (
            <div className='rounded-bar'>
                <span className='icon-search'/>
                <TranslatedInput
                    className='rounded-input'
                    onChange={this.handleTranslatedInputChange}
                    placeholder={this.props.placeholder}
                    type={this.props.type}
                    value={this.state.value}
                />
            </div>
        );

    }
}

FacetFilter.displayName = 'FacetFilter';
FacetFilter.propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string
};
FacetFilter.defaultProps = {
    type: 'text',
    value: ''
};

export default FacetFilter;



// WEBPACK FOOTER //
// ./src/shared/components/facets/facet-filter/index.js